/**
 * List of options for the Zone types field
 *
 * @namespace tmrZoneTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrZoneTypes',
  {
    INBOUND: 'ZONETYPES.INBOUND',
    LOST: 'ZONETYPES.LOST',
    SOLD: 'ZONETYPES.SOLD',
    STOCK: 'ZONETYPES.STOCK',
  },
]

/**
 * Translates {@link tmrZoneTypes}
 *
 * @type {ngRun}
 */
let tmrZoneTypesRun = /*@ngInject*/ (TmrTranslate, tmrZoneTypes) =>
  TmrTranslate.object(tmrZoneTypes)

export { tmrZoneTypesRun as run }
